import { createMainResourceREST } from '../resource';
import {
  CRDocumentViewerItem,
  CRDocumentViewerItemAPI,
  CRDocumentViewerKey,
  DocumentViewerActions,
  DocumentViewerState,
} from './types';

type AnyDocumentViewer = CRDocumentViewerKey | CRDocumentViewerItem | undefined;

function sameKeyDocumentViewer(
  a: AnyDocumentViewer,
  b: AnyDocumentViewer,
): boolean {
  return a?.document.documentToken === b?.document.documentToken;
}

function getEndpointDocumentViewer(key: AnyDocumentViewer) {
  const documentEndpoint =
    key?.document.documentEndpoint === 'credit'
      ? 'invoice'
      : key?.document.documentEndpoint === 'estimate'
      ? 'quote'
      : key?.document.documentEndpoint;
  return `/viewer-toolbox/${documentEndpoint}/?documentToken=${key?.document.documentToken}`;
}

function parseDocumentViewer(
  documentViewer: CRDocumentViewerItemAPI,
): CRDocumentViewerItem {
  const {
    document: { items, taxes, ...document },
    branch,
  } = documentViewer;

  return {
    document,
    items,
    taxes,
    branch,
  };
}

const documentViewerStateSelector = (state: any): DocumentViewerState =>
  state.documentViewer;

function mergeDocumentViewer(
  last: CRDocumentViewerItem,
  current: CRDocumentViewerItem,
) {
  return current;
}
function mergeSummaryBody(
  oldSummary?: CRDocumentViewerItem,
  currentBody?: CRDocumentViewerItem,
) {
  return (currentBody ?? oldSummary)!;
}

const { actions, reducer, watches } = createMainResourceREST(
  'viewer-toolbox',
  getEndpointDocumentViewer,
  documentViewerStateSelector,
  sameKeyDocumentViewer,
  parseDocumentViewer,
  parseDocumentViewer,
  mergeDocumentViewer,
  mergeSummaryBody,
);

const documentViewerActions: DocumentViewerActions = actions;
export {
  documentViewerActions,
  reducer as documentViewerReducer,
  watches as documentViewerWatches,
};

export * from './types';
